import constants from "./constants";

export default {
    methods: {
        getConstant(key) {
            return constants.get(key);
        },
    },
};
